import React from 'react'

import {
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader
} from '@clientbase/clientbase-library'

import ActionsButton from './Actions/Actions'
import BillingDetails from './BillingDetails'
import Header from './Header'
import NegativateDetail from './NegativateDetail'
import PayerDetails from './PayerDetails'

const DetailBody = ({ handleClose }: { handleClose: () => void }) => {
  return (
    <ModalBody>
      <ModalHeader onClose={handleClose}>
        <Header />
      </ModalHeader>
      <ModalContent>
        <BillingDetails />
        <PayerDetails />
        <NegativateDetail />
      </ModalContent>
      <ModalFooter>
        <ActionsButton />
      </ModalFooter>
    </ModalBody>
  )
}

export default DetailBody
